import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  grid-gap: 1rem;
  margin-bottom: 1rem;

  .contentWrapper {
    padding: 16px 16px 0 16px;
    border: 1px solid #e9ebee;

    border-radius: 8px;
  }
`;
